import { BaseRow } from '../tableHelpers';

export function allItemsSelected<RowT extends BaseRow>(items: RowT[], selectedItems: RowT[]): boolean {
  return items.length !== 0 && items.every(singleItem => selectedItems.includes(singleItem));
}

export function anyItemSelected<RowT extends BaseRow>(items: RowT[], selectedItems: RowT[]): boolean {
  return items.length !== 0 && items.some(singleItem => selectedItems.includes(singleItem));
}
